import React from "react";
import { Sidebar } from "../../components/sidebar/Sidebar";
import { Outlet } from "react-router-dom";

export const Layout = () => {
  return (
    <div className="flex h-screen w-full bg-[#F7F7F7]">
      {/* Sidebar*/}
      <aside className="hidden md:flex w-[230px] min-h-screen bg-white border-r border-border_color pt-5 pb-2 rounded-tr-[30px] rounded-br-[30px] items-start justify-center relative z-50">
        <Sidebar />
      </aside>

      <div className="flex flex-col flex-1 min-w-0">
        <main className="flex-1 bg-[#F7F7F7] p-6 mt-10 md:mt-20 overflow-y-auto ">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
